import React, { useState, useCallback, useRef, useEffect } from "react";

import { Modal } from "react-bootstrap";

import { debounce } from "lodash";

import useAxios from "../services/useAxios";

import {
  ProductSearch,
  SupplierSearch,
} from "../components/common/searchComponents";

import CustomButton from "../components/kits/custom-button/CustomButton";

import { ArrowRightIcon } from "../components/kits/Icons/Icons";
import { CustomInput, CustomInputProps } from "../components/kits/inputs/Input";

import ColorSchema from "../assets/kits/colors";
import { pathMaker } from "../utilities/helperFunctions";
import BoxSlider from "../components/common/slider/BoxSlider";
import {getBoxByPosition} from "../utilities/apiTools";

interface Props extends CustomInputProps {}

type SearchType = {
  suppliers: {
    id: number;
    title: string;
    delivery_cost: number;
  }[];
  products: {
    id: number;
    title: string;
    supplier_id: number;
    supplier_title: string;
    price: number;
    path: string;
  }[];
};

const WithSearch: React.FC<Props> = ({ ...props }) => {
  const { execute: searchHome } = useAxios("api/search_home");

  const [show, setShow] = useState<boolean>(false);
  const [data, setData] = useState<SearchType>({
    suppliers: [],
    products: [],
  });

  const searchDebounce = useRef(
    debounce((text: string): void => {
      if (text !== "") {
        searchHome({
          text,
        }).then((res) => {
          setData(res.data);
        });
      } else {
        resetData();
      }
    }, 1000)
  );

  const hideModal = useCallback(() => setShow(false), [setShow]);

  const resetData = useCallback(
    () => setData({ products: [], suppliers: [] }),
    [setData]
  );

  useEffect(() => {
    if (show) {
      resetData();
    }
  }, [show, resetData]);


  const [boxBanners, setBoxBanners] = useState({})

  useEffect(() => {
    // @ts-ignore
    const loadBanner = async () => setBoxBanners(await getBoxByPosition("f17,f18"));
    loadBanner();
  }, []);

  return (
    <>
      <CustomInput
        {...props}
        onClick={(event) => {
          setShow(true);
          props.onClick && props.onClick(event);
        }}
        tabIndex={-1}
        onFocus={(event) => {
          if (event.relatedTarget instanceof HTMLElement) {
            event.relatedTarget?.focus();
          } else {
            event.target.blur();
          }
        }}
        value=""
      />

      <Modal className="search-box" show={show} onHide={hideModal}>
        <Modal.Header
          className="d-flex justify-content-start pd-y-12 pd-x-20 border-0"
          style={{ margin: 0 }}
        >
          <CustomButton className="p-0" buttonStyle="text" onClick={hideModal}>
            <ArrowRightIcon />
          </CustomButton>
        </Modal.Header>
        <Modal.Body className="pd-t-8 pd-x-20" style={{ margin: 0 }}>
            {/*@ts-ignore*/}
            {(boxBanners.f17) && (
                <div className="mr-b-12">
                  {/*@ts-ignore*/}
                  <BoxSlider banner={boxBanners.f17}/>
                </div>
            )}

          <CustomInput
            onChange={(event) => {
              searchDebounce.current(event.target.value);
            }}
            {...props}
          />
          {/*@ts-ignore*/}
          {(boxBanners.f18) && (
              <div className="mr-b-12">
                {/*@ts-ignore*/}
                <BoxSlider banner={boxBanners.f18}/>
              </div>
          )}

          {/* suppliers Section */}
          <div className="mr-t-24">
            {data.suppliers.length > 0 && (
              <>
                <h4 className="title-h4-b">فروشگاه‌ها</h4>
                {data.suppliers.reduce<JSX.Element[]>((total, shop, index) => {
                  if (index !== 0) {
                    total.push(
                      <hr
                        key={`shop-hr-${index}`}
                        style={{
                          width: "100%",
                          height: 1,
                          color: ColorSchema.foreground_background_me,
                          opacity: "0.1",
                          padding: 0,
                          margin: 0,
                        }}
                      />
                    );
                  }
                  total.push(
                    <SupplierSearch
                      key={`shop-${shop.id}`}
                      title={shop.title}
                      deliveryCost={shop.delivery_cost}
                      link={`shop/${shop.id}`}
                    />
                  );
                  return total;
                }, [])}
              </>
            )}
            {data.products.length > 0 && (
              <>
                <h4 className=" title-h4-b mr-t-20">محصولات</h4>
                {data.products.reduce<JSX.Element[]>(
                  (total, product, index) => {
                    if (index !== 0) {
                      total.push(
                        <hr
                          key={`product-hr-${index}`}
                          style={{
                            width: "100%",
                            height: 1,
                            color: ColorSchema.foreground_background_me,
                            opacity: "0.1",
                            padding: 0,
                            margin: 0,
                          }}
                        />
                      );
                    }
                    total.push(
                      <ProductSearch
                        key={`shop-${product.id}`}
                        title={product.title}
                        supplierTitle={product.supplier_title}
                        price={product.price}
                        imageSrc={pathMaker(product.path)}
                        link={`product/${product.supplier_id}/${product.id}`}
                      />
                    );
                    return total;
                  },
                  []
                )}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WithSearch;
